import React from "react";

const Loader = ({ type = "spinner", fullscreen = true, color, opacity }) => {
  const loaderColor = color ? color : "#de2b26";

  // Spinner Loader
  const spinner = (
    <div
      className="w-10 h-10 border-4 border-t-transparent rounded-full animate-spin"
      style={{
        borderColor: `${loaderColor} transparent ${loaderColor} ${loaderColor}`,
      }}
    ></div>
  );

  // Dots Loader
  const dots = (
    <div className="flex space-x-2">
      {[0, 1, 2].map((i) => (
        <span
          key={i}
          className="w-3 h-3 rounded-full animate-bounce"
          style={{
            backgroundColor: loaderColor,
            animationDelay: `${i * 0.2}s`,
          }}
        ></span>
      ))}
    </div>
  );

  // Bar Loader
  const bar = (
    <div className="w-40 h-2 bg-gray-200 rounded-full overflow-hidden">
      <div
        className="h-full animate-pulse"
        style={{ backgroundColor: loaderColor }}
      ></div>
    </div>
  );

  const loaderTypes = {
    spinner,
    dots,
    bar,
  };

  return (
    <div
      className={`fixed top-0 left-0 flex items-center justify-center ${
        fullscreen ? "fixed inset-0 z-50" : ""
      } ${opacity ? `bg-white/80` : "bg-white"}`}
    >
      {loaderTypes[type] || spinner}
    </div>
  );
};

export default Loader;
